<template>
  <component
    :is="type"
    class="button is-light flex font-semibold"
    :class="[is_outlined ? 'is-outlined' : '', is_rounded ? 'rounded-full' : '', is_small ? 'is-small' : '']"
    :disabled="is_disabled || null"
    :to="to"
    @click="submit"
  >
    <div
      v-if="icon_name"
      class="icon"
    >
      <AppIcon :name="icon_name" />
    </div>
    <div>
      <slot />
    </div>
  </component>
</template>

<script setup>
import { computed } from 'vue';
import { BUTTON_LIGHT_ACTIONS_TO_ICON } from '@/app/data/button_constants';

const props = defineProps({
  is_disabled: { type: Boolean },
  is_outlined: { type: Boolean },
  is_small: { type: Boolean },
  to: { type: Object, default: null },
  is_rounded: { type: Boolean },
  action: {
    type: String,
    default: null,
    validator: (prop) => Object.keys(BUTTON_LIGHT_ACTIONS_TO_ICON).includes(prop),
  },
});

const emit = defineEmits(['onClick']);

const icon_name = BUTTON_LIGHT_ACTIONS_TO_ICON[props.action];

const type = computed(() => (props.to ? 'AppLink' : 'div'));

function submit(event) {
  if (props.is_disabled) return;
  emit('onClick', event);
}
</script>
